import React from 'react';
import { Route } from 'react-router-dom';
import { setTitle } from '../utils/misc';

export default ({ component: C, props: cProps, title, ...rest }) => {
  setTitle(title);
  return <Route {...rest} render={props => <C {...props} {...cProps} />} />;
};



// WEBPACK FOOTER //
// ./src/components/AppliedRoute.js